// START FUNCTIONS
animateBanner();
observerAnimation();
doCart();

// NAV - GLOBAL MENU
function showHide_GlobalNav () {

    const e = document.getElementById("custom-nav-global");

    if ( e.classList.contains("custom-nav-global-show") ) {

        e.classList.add("custom-nav-global-hide");

        setTimeout( () => {
            e.classList.remove("custom-nav-global-hide");
            e.classList.remove("custom-nav-global-show");
        }, 400 );

    } else {

        e.classList.add("custom-nav-global-show");

    };

}

// BANNER - MAIN PAGE
function animateBanner () {

    const e = document.getElementsByClassName("custom-animate-banner"),
    delay = 4;

    if ( e[0] ) {

        const tar = e[0].firstElementChild.lastElementChild,
        rotations = tar.childElementCount + 2 ;

        for (let i = 0; i < rotations; i++) {
            
            setTimeout( () => {

                if ( i > 0 && i < rotations-2 ) {

                    tar.children[i-1].classList.add("fade-out");
                    tar.children[i].classList.add("rotate-in");
                
                } else if ( i == rotations-2 ) {

                    tar.children[i-1].classList.remove("rotate-in");
                    tar.children[i-1].classList.add("fade-out");
                    tar.children[0].classList.remove("fade-out");
                    tar.children[0].classList.add("fade-in");

                } else if ( i == rotations-1 ) {

                    for (let z = 0; z < tar.childElementCount; z++) {

                        tar.children[z].classList.remove("fade-in");
                        tar.children[z].classList.remove("fade-out");
                        tar.children[z].classList.remove("rotate-in");

                        if ( z == tar.childElementCount-1 ) {
                            animateBanner();
                        };

                    };

                };

            }, 1000*(delay*i) );

        };

    };

}

// OBSERVER - ANIMATE WHEN VISIBLE

function observerAnimation () {

    const ioConfiguration = { rootMargin: "-60% 0% -40% 0%", threshold: 0 };

    const observer = new IntersectionObserver((entries) => {

        entries.forEach((entry) => {

            if ( entry.isIntersecting ) {

                entry.target.classList.add("animateWhenVisible-visible");

            };

        });

    }, ioConfiguration);

    const animateWhenVisibleElements = document.querySelectorAll(".animateWhenVisible");

    animateWhenVisibleElements.forEach((el) => observer.observe(el));

}

// CHECK CART FOR ITEMS

async function getCart() {
  
    const result = await fetch("/cart.json");

    if (result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
  
}
async function doCart() {

  const cart = await getCart(),
        eCart = document.getElementById("custom-header-nav-icons");

  if ( cart.item_count > 0 ) {

    eCart.classList.add("custom-header-nav-icons-cart-active");
    
  } else {

    eCart.classList.remove("custom-header-nav-icons-cart-active");
    
  };
  
}